<template>
  <div class="container" id="container">
    <div class="row mb-1 mt-1  d-flex justify-content-center">
      <div class="col-12 sm:12">
        <Breadcrumb :home="home" :model="breadcrumbitems" />
      </div>
    </div>
    <div class="row mb-1 mt-1 d-flex justify-content-center">
        <div class="col-12 sm:12">
          <component :is="Component" @prev-page="prevPage($event)" @next-page="nextPage($event)" @CheckStatus="CheckUserStatus" @complete="complete" v-bind="Props" />
      </div>
    </div>
  </div>
 </template>

<style>

     html, body, #app {
        height: 100%
    }

    .v-stepper__wrapper{
        height:100%;
    }
</style>
<script>
  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
  
  import Breadcrumb from 'primevue/breadcrumb';
  import { defineAsyncComponent } from 'vue'

  export default {
    props: ['OrgId','AssessmentId'],
      components: {
      Breadcrumb
    },
    data: () => ({
          CreateAssessmentComponents: {
          AssessmentDetails: defineAsyncComponent(() => import('./PartOne.vue')),
          AssessmentQuestions: defineAsyncComponent(() => import('./PartTwo.vue'))
      },
      Component:null,
    
         Props: null,
         home: { icon: 'pi pi-home', to: '/' },
         breadcrumbitems: [
                    {
                        label: 'Manage Assessments',
                        disabled: false,
                        to: '/ManageAssessments',
                    },
                    {
                        label: 'Create Assessment',
                        disabled: true,
          }],
        }),
       async created() {

            var self = this;

            self.$emit("set-nav", this.$route)

            self.Props = {
             AssessmentId: this.AssessmentId,
             OrganizationId: this.OrgId
            }

            self.Component = self.CreateAssessmentComponents.AssessmentDetails;
       },
       methods: {
         nextPage(event) {
                 this.Props = event.Props;
                 this.Component = this.CreateAssessmentComponents.AssessmentQuestions
         },
         prevPage(event) {
           this.Props = event.Props;
           this.Component = this.CreateAssessmentComponents.AssessmentDetails
         },
        }
      }
</script>